import React, { createContext, useContext } from "react";

export interface BrandingConfig {
  logoSrc: string;
  logoAlt: string;
  appName: string;
  orgBucket: string; // The search/ES bucket name for organizations (app-specific)
}

const BrandingContext = createContext<BrandingConfig>({
  logoSrc: "",
  logoAlt: "Platform",
  appName: "Platform",
  orgBucket: "organizations",
});

export const BrandingProvider = BrandingContext.Provider;

export function useBranding() {
  return useContext(BrandingContext);
}
